module.exports = __webpack_public_path__ + "static/media/desk.4115bc29.jpg";